import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'motes-toggle',
    templateUrl: './motes-toggle.component.html',
    styleUrls: ['./motes-toggle.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MotesToggleComponent implements OnInit {

    @Input() checked: boolean = false;
    @Input() disabled: boolean = false;
    @Input() tiny: boolean = false;
    @Output() checkedChange = new EventEmitter<boolean>();

    constructor() { }

    ngOnInit(): void {
    }

    public onToggle() {
        if(this.disabled) return;
        this.checked = !this.checked;
        this.checkedChange.emit(this.checked);
    }

}
